import { Filter } from './filter.js';

export class Alpha2ColorFilter extends Filter {
    _color: number[];

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'alpha2Color', 'Alpha vers couleur');
        this.reset();
    }

    get color() {
        return this._color;
    }

    set color(value) {
        var self = this;
        self._color = value;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._color = [246 / 255, 246 / 255, 246 / 255, 1];
    }

}
